import { Staff } from "../models/Staff";

const _key = "igenie_auth";

// Read from local storage
function readLoadStorage() {
	const data = localStorage.getItem(_key);
	if (data) {
		const object = JSON.parse(atob(data));
		if (object && "staff" in object && "token" in object) {
			return object;
		}
	}
	return null;
}
//  Write to localStorage
function writeToLocalStorage(data) {
	// clear any existing item
	localStorage.removeItem(_key);
	// save new one
	localStorage.setItem(_key, data);
}

class AuthenticationProvider {
	isLoggedIn = false;
	staff = null;
	token = null;
	constructor() {
		const data = readLoadStorage();
		if (data) {
			this.isLoggedIn = true;
			this.staff = new Staff(data.staff);
			this.token = data.token;
		}
	}

	GetAuthenticatedStaff() {
		// Update method
		const data = readLoadStorage();
		if (data && "staff" in data) {
			return new Staff(data.staff);
		}
		return null;
	}
	GetToken() {
		// Update method
		const data = readLoadStorage();
		if (data && "token" in data) {
			return data.token;
		}
		return "";
	}

	LogOut() {
		// clear localStorage
		localStorage.clear();
	}

	/**
	 *Logs staff in
	 * @param {Staff} staff staff object
	 * @param {string} token generated token
	 */
	async Login(staff, token) {
		if (staff && token) {
			const _base64 = btoa(JSON.stringify({ staff, token }));
			// update local storage
			writeToLocalStorage(_base64);
			// read the updated local storage
			const data = readLoadStorage();
			if (data) {
				this.isLoggedIn = true;
				this.staff = new Staff(data.staff);
				this.token = data.token;
			}
			return true;
		}
		return false;
	}

	/**
	 * Gets staff token
	 */
	GetBearerAuthentication() {
		const data = readLoadStorage();
		if (data && "token" in data) {
			return { Authorization: `Bearer ${data.token}` };
		} else {
			return { Authorization: "" };
		}
	}
	/**
	 * Checks if the suplied message is an authentication error
	 * @param {string} value error message
	 */
	IsAuthenticationError(value) {
		return (
			value.includes("Unauthorized access!") ||
			value.includes("Unauthorised access!") ||
			value.includes("Unauthorized Access")
		);
	}
}

// export const ;
// export const key = _key;
export default {
	key: _key,
	authProvider: new AuthenticationProvider()
};
